<template>
  <el-dialog :visible.sync="visible" title="批量生成发票号" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
      <el-form-item label="公司户头：" prop="accountId">
        <account v-model="dataForm.accountId"></account>
      </el-form-item>
      <el-form-item label="发票年度：" prop="year">
        <el-date-picker
            v-model="dataForm.year"
            type="year"
            value-format="yyyy"
            placeholder="选择年">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="生成数量：" prop="count">
        <el-input v-model="dataForm.count" placeholder="真实发票号"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()" :disabled="loading">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { isInt } from '@/utils/validate'
import CommonDrop from '@/components/CommonDrop'
import moment from 'moment'
export default {
  components:{CommonDrop},
  data () {
    return {
      id: '',
      visible: false,
      loading:false,
      dataForm: {

      }
    }
  },
  computed: {
    dataRule () {
      return {
        count: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' },
          {
            validator: function (rule, value, callback) {
              if (!isInt(value)) {
                callback(new Error('请输入正确的数量'))
                return
              }
              callback()
            },
            trigger: 'change',
          },
        ], year: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ], accountId: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    reset () {
      this.dataForm = {
        accountId: '',
        year: moment().format('YYYY'),
        count: 20
      }
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].resetFields()
      }
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.reset()
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let postForm = {
          ...this.dataForm
        }
        if(this.loading){
          return
        }
        this.loading = true
        this.$api2.post('/erp/box/code/batch', postForm).then(res => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.loading = false
              this.cancel()
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {
          this.loading = false
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    cancel () {
      this.visible = false
    }
  }
}
</script>
